/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Stage_Picked_UpInputs */

const vi_carrier_stage_picked_up = /** @type {(inputs: Carrier_Stage_Picked_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hãng đã lấy hàng`)
};

/**

* @param {Carrier_Stage_Picked_UpInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_stage_picked_up = /** @type {((inputs?: Carrier_Stage_Picked_UpInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Stage_Picked_UpInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_stage_picked_up(inputs)
});